module.exports = __webpack_public_path__ + "static/ogimg-corporate-profile-3bd6eaa140d18d0172c8b54205c02de3.jpg";